import React from 'react';
import { useView } from '../../contexts/ViewContext';
import StrategicPillars from './StrategicPillars';
import StrategicPillarDetailPage from './StrategicPillarDetailPage';
import StrategicPillarEditor from './StrategicPillarEditor';

const StrategicPillarsWrapper: React.FC = () => {
  const { view, setView } = useView();

  if (view.subPage === 'detail' && view.id) {
    return <StrategicPillarDetailPage strategicPillarId={view.id as string} setView={setView} />;
  }

  if (view.subPage === 'edit' || view.subPage === 'new') {
    return (
      <StrategicPillarEditor
        pillarId={view.id}
        onBack={() => setView({ page: 'Strategic Pillars' })}
        onSuccess={() => setView({ page: 'Strategic Pillars' })}
      />
    );
  }

  return <StrategicPillars setView={setView} />;
};

export default StrategicPillarsWrapper;
